import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Common } from 'src/shared/common';
import { catchError, Observable, retry } from 'rxjs';
import 'rxjs-compat/add/observable/of';
import { Constants } from '../constant';
import { Course } from '../models/course';


@Injectable()
export class CourseService {

  constructor(private http: HttpClient) { }

  getAllCourses() {
    return this.http.get<Course>(Constants.getApiEndpoint() + '/course_master/all');
  }

  getCoursesList(pgIndex: number, pageSize: number) {
    return this.http.get<Course>(Constants.getApiEndpoint() + '/course_master?page=' + pgIndex + "&size=" + pageSize)
      .pipe(retry(1), catchError(Common.handleError));
  }

  getCourse(id: string) {
    if (id === "new") {
      return Observable.of(this.initializeCourse());
    };
    return this.http.get<Course>(Constants.getApiEndpoint() + '/course_master/' + id).pipe(retry(1), catchError(Common.handleError));
  }

  deleteCourseMaster(id: string) {
    return this.http.delete<Course>(Constants.getApiEndpoint() + '/course_master/' + id).pipe(retry(1), catchError(Common.handleError));
  }

  saveCourseMaster(course: Course) {
    if (course.id === null) {
      return this.createCourseMaster(course);
    }
    return this.updateCourseMaster(course);
  }

  private createCourseMaster(course: Course) {
    course.id = undefined;
    return this.http.post<Course>(Constants.getApiEndpoint() + '/course_master', JSON.stringify(course), Common.httpOptions)
      .pipe(retry(1), catchError(Common.handleError));
  }

  private updateCourseMaster(course: Course) {
    return this.http.put<Course>(Constants.getApiEndpoint() + '/course_master', JSON.stringify(course), Common.httpOptions)
      .pipe(retry(1), catchError(Common.handleError));
  }

  initializeCourse(): Course {
    // Return an initialized object
    return {
      id: null,
      code: null,
      name: null,
      active: false
    };
  }
}
